export default `float de(vec3 p){
    vec3 Q;
    float i,d=1.;
    Q=p;
    d=.4*M_PI;
    Q.yx*=rotate2D(floor(atan(Q.x,Q.y)/d+.5)*d);
    Q.zx=abs(Q.zx);
    return d=max(Q.z-.06,(Q.y*.325+Q.x+Q.z*1.5)/1.83-.05);
  }`